<div *ngIf="documents" data-testid="doc-upload-container">
  <label
    *ngIf="
      documents.length < 1 && context == 'facility' && type == 'state_license'
    "
    data-testid="doc-label-state-license"
  >
  </label>
  <label
    *ngIf="
      documents.length < 1 && context == 'facility' && type == 'dea_license'
    "
    data-testid="doc-label-dea-license"
  >
  </label>
  <label
    *ngIf="
      documents.length < 1 &&
      context == 'facility' &&
      type == 'reseller_certificate'
    "
    data-testid="doc-label-reseller-cert"
  >
    <app-ms-tooltip
      tooltipKey="RESELLER_CERTIFICATE"
      width="300"
      id="usl_pi"
      extraClass="badge-default"
    >
    </app-ms-tooltip>
    Upload a reseller certificate:
  </label>
</div>

<!-- Warning alert for state license - shown at top -->
<div *ngIf="
    documents?.length < 1 && context == 'facility' && type == 'state_license'
  " class="alert alert-warning upload-warning" data-testid="doc-alert-state-license-required">
  Please upload your state license to make purchases.
</div>

<div
  *ngIf="
    (!disableUpload && !disabled && filteredDocuments.length < limit) ||
    persistUploadButton
  "
  class="upload-section"
  data-testid="doc-upload-section"
>
  <div class="upload-button-row">
    <dx-file-uploader selectButtonText="Choose file" [multiple]="false" [(value)]="filesToUpload" labelText=""
      uploadMode="useForm" [allowedFileExtensions]="allowedFileExtensions" (onValueChanged)="uploadFile()"
      class="compact-uploader"
      [elementAttr]="{ 'data-testid': 'doc-uploader-file' }"
    >
    </dx-file-uploader>
  </div>
  <div class="file-extensions-row">
    <span class="note" data-testid="doc-note-extensions">Allowed file extensions:
      <span *ngFor="let ext of allowedFileExtensionsAllCases">{{ ext }} </span>
    </span>
  </div>
</div>

<div *ngIf="documents" class="row" data-testid="doc-list">
  <div *ngFor="let document of filteredDocuments" class="col-sm-12 col-md-12">
    <div class="d-flex flex-row align-items-center" [attr.data-testid]="'doc-item-' + document.id">
      <a *ngIf="preview" [routerLink]="[]" (click)="documentOpen(document)" data-testid="doc-link-preview">
        <img [src]="document.url" style="max-width: 100px; max-height: 100px" />
      </a>
      <span class="link" (click)="documentOpen(document)" data-testid="doc-link-open"
        >{{ document.uri }}
      </span>
      <dx-button
        *ngIf="showDelete || context == 'order' || context == 'profile'"
        stylingMode="text"
        icon="trash"
        type="danger"
        (onClick)="askDelete(document)"
        class="ml-2"
        [elementAttr]="{ 'data-testid': 'doc-btn-delete-' + document.id }"
      >
      </dx-button>
    </div>
  </div>
</div>

<dx-popup
  *ngIf="askDeleteVisible"
  [width]="380"
  [height]="170"
  [showTitle]="true"
  title="Delete File"
  [dragEnabled]="false"
  [hideOnOutsideClick]="true"
  [showCloseButton]="true"
  [(visible)]="askDeleteVisible"
  [elementAttr]="{ 'data-testid': 'doc-popup-delete-confirm' }"
>
  <div *dxTemplate="let data of 'content'">
    <p>Are you sure you want to delete this file?</p>
    <div class="row">
      <div class="col-6 text-left">
        <dx-button
          text="Yes"
          type="danger"
          width="120"
          [elementAttr]="{ 'data-testid': 'doc-btn-confirm-delete' }"
          (onClick)="documentCurrentDelete()"
        >
        </dx-button>
      </div>
      <div class="col-6 text-right">
        <dx-button text="No" type="default" width="120" (onClick)="noClick()"
          [elementAttr]="{ 'data-testid': 'doc-btn-cancel-delete' }">
        </dx-button>
      </div>
    </div>
  </div>
</dx-popup>


<dx-popup *ngIf="isProcessing" [width]="'85%'" [maxWidth]="400" [height]="'auto'" [showTitle]="true"
  title="Processing Upload" [dragEnabled]="false" [hideOnOutsideClick]="false" [showCloseButton]="false"
  [(visible)]="isProcessing"
  [elementAttr]="{ 'data-testid': 'doc-popup-processing' }">
  <div *dxTemplate="let data of 'content'">
    <p class="text-center mb-3">{{ processMessage }}</p>

    <dx-progress-bar [min]="0" [max]="100" [value]="progressValue" [showStatus]="false" class="mb-3"
      [elementAttr]="{ 'data-testid': 'doc-progress-bar' }">
    </dx-progress-bar>

    <div class="text-center" *ngIf="canCloseProcessing">
      <dx-button text="OK" type="default" width="120" (onClick)="closeProcessingModal()"
        [elementAttr]="{ 'data-testid': 'doc-btn-ok-processing' }">
      </dx-button>
    </div>
  </div>
</dx-popup>
